module.exports = __webpack_public_path__ + "2ee67909232b85f41e64eebf72b5d229.svg";